export default __webpack_public_path__ + "assets/models/79d0d37021009a931d9eead163001537.glb";